import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './ui/App';
// tokens.css must precede styles.css: it defines the scales and redefines the ten original
// variables in terms of them, so every existing rule keeps resolving.
import './ui/tokens.css';
import './ui/motion.css';
import './ui/components.css';
import './ui/styles.css';

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
